import Error from 'components/form/Error';
import Accepted from 'components/Interview/AdminPages/Accepted';
import Cancelled from 'components/Interview/AdminPages/Cancelled';
import Late from 'components/Interview/AdminPages/Late';
import NoAnswer from 'components/Interview/AdminPages/NoAnswer';
import Refused from 'components/Interview/AdminPages/Refused';
import ReviewDisplay from 'components/Interview/AdminPages/ReviewDisplay';
import WaitingMentee from 'components/Interview/AdminPages/WaitingMentee';
import { DefaultLoader, LoaderContainer } from 'components/Loader';
import { PageBack, PageHeadContainer, PageTitle } from 'components/PageHead';
import React, { FC, useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import useSWR from 'swr';
import Interview from 'types/Interview';
import Head from './Head';

const PageBackContainer = styled.div`
  margin-bottom: auto;
  font-size: 1.5rem;
`;

type ContextType = {
  interview: Interview | undefined;
};
export const ReviewPageContext = React.createContext({} as ContextType);
const { Provider } = ReviewPageContext;

const ReviewPage: FC = ({ children }) => {
  const { interviewId } = useParams();
  const { data: interview, error } = useSWR<Interview>(
    `/interview/details/${interviewId}`,
  );

  const value = useMemo(
    () => ({
      interview,
    }),
    [interview],
  );
  return !error ? (
    interview ? (
      <Provider value={value}>{children}</Provider>
    ) : (
      <LoaderContainer>
        <DefaultLoader size={1.5} />
      </LoaderContainer>
    )
  ) : (
    <>
      <PageHeadContainer>
        <PageTitle>
          <PageBackContainer>
            <PageBack href="/mentee/mentorship/management/interviews" />
          </PageBackContainer>
          <h1>Entretien</h1>
        </PageTitle>
      </PageHeadContainer>
      <Error>Une erreur est survenue.</Error>
    </>
  );
};

const DisplayedPage: FC = () => {
  const { interview } = useContext(ReviewPageContext);

  switch (interview?.status) {
    case 'WAITING_MENTEE':
      return <WaitingMentee interview={interview} />;
    case 'REFUSED':
      return <Refused />;
    case 'ACCEPTED':
      return <Accepted interview={interview} />;
    case 'WAITING_REVIEW':
    case 'FINISHED':
      return <ReviewDisplay interview={interview} />;
    case 'NO_ANSWER':
      return <NoAnswer interview={interview} />;
    case 'CANCELLED':
      return <Cancelled />;
    case 'LATE':
      return <Late interview={interview} />;
    default:
      return null;
  }
};

const Usage: FC = (props) => {
  return (
    <ReviewPage {...props}>
      <Head />
      <DisplayedPage />
    </ReviewPage>
  );
};

export default Usage;
